<form [formGroup]="applicantInfoForm">
  <div class="flex flex-col gap-2">
    <div class="flex flex-col md:flex-row gap-4 portal-section-grid">
      <!-- Display View -->
      <mat-card class="md:w-1/2 w-full" *ngIf="!isEditable">
        <mat-card-content>
          <div class="applicant-details">
            <span class="font-semibold text-xl">Applicant Information</span>
            <div class="applicant-field-row">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Last</span>
                <span>{{ applicantInformation.lastName }}</span>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">First</span>
                <span>{{ applicantInformation.firstName }}</span>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Middle</span>
                <span>{{ applicantInformation.middleName }}</span>
              </div>
            </div>

            <div class="applicant-field-row">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Prior Name Used</span>
                <span>{{ applicantInformation.priorName }}</span>
              </div>
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Gender</span>
                <span>{{ applicantInformation.gender }}</span>
              </div>
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Date Of Birth</span>
                <span>{{ applicantInformation.dateOfBirth | date }}</span>
              </div>
            </div>

            <div class="applicant-field-row">
              <div class="flex flex-col md:w-1/3">
                <div class="flex flex-row -mt-4 items-center portal-actions">
                    <span class="font-semibold">Email</span>
                    <button mat-icon-button color="primary" [matTooltip]="'Copy Email'" matTooltipShowDelay="800" aria-label="Copy Email"
                            (click)="sharedService.copyToClipboard(applicantInformation.email)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <span>{{ applicantInformation.email }}</span>
              </div>
              <div class="flex flex-col gap-4 md:w-1/3">
                <span class="font-semibold">Telephone</span>
                <span>{{ applicantInformation.phone | mask:"000-000-0000" }}</span>
              </div>
              <div class="flex flex-col md:w-1/3">
                <span class="font-semibold">Social Security Number</span>
                <div class="flex flex-row gap-2 items-center portal-actions">
                  <span *ngIf="showSsn">{{ applicantInformation.ssn | mask:"000-00-0000" }}</span>
                  <span *ngIf="!showSsn">XXX-XX-XXXX</span>
                  <button mat-icon-button [color]="showSsn ? 'primary' : 'warn'" [matTooltip]="showSsn ? 'Hide SSN' : 'Show SSN'"
                          matTooltipShowDelay="800" aria-label="Toggle SSN" (click)="toggleSsn()">
                          <mat-icon>{{ showSsn ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Edit View -->
      <mat-card class="md:w-1/2 w-full" *ngIf="isEditable">
        <mat-card-content>
          <div class="applicant-details">
            <span class="font-semibold text-xl">Applicant Information</span>
            <div class="applicant-field-row">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Last Name</span>
                <mat-form-field>
                  <mat-label>Last</mat-label>
                  <input matInput formControlName="lastName">
                  <mat-error *ngIf="applicantInfoForm.get('lastName')?.hasError('required')">
                    Last Name required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">First Name</span>
                <mat-form-field>
                  <mat-label>First</mat-label>
                  <input matInput formControlName="firstName">
                  <mat-error *ngIf="applicantInfoForm.get('firstName')?.hasError('required')">
                    First Name required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Middle Name</span>
                <mat-form-field>
                  <mat-label>Middle</mat-label>
                  <input matInput formControlName="middleName">
                  <mat-error *ngIf="applicantInfoForm.get('middleName')?.hasError('required')">
                    Middle Name required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="applicant-field-row">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Prior Name Used</span>
                <mat-form-field>
                  <mat-label>Prior Name</mat-label>
                  <input matInput formControlName="priorName">
                </mat-form-field>
              </div>
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Gender</span>
                <mat-form-field>
                  <mat-label>Gender</mat-label>
                  <input matInput formControlName="gender">
                  <mat-error *ngIf="applicantInfoForm.get('gender')?.hasError('required')">
                    Gender is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Date Of Birth</span>
                <mat-form-field class="form-field">
                  <mat-label>DOB</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="dateOfBirth">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="applicantInfoForm.get('dateOfBirth')?.hasError('required')">
                    Date Of Birth is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="applicant-field-row">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Email</span>
                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email">
                  <mat-error *ngIf="applicantInfoForm.get('email')?.hasError('email')">
                    Enter a valid email address
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Telephone</span>
                <mat-form-field>
                  <mat-label>Telephone</mat-label>
                  <input matInput formControlName="phone" mask="000-000-0000" maxlength="12">
                  <mat-error *ngIf="applicantInfoForm.get('phone')?.hasError('required')">
                    Phone number required
                  </mat-error>
                  <mat-error *ngIf="applicantInfoForm.get('phone')?.hasError('pattern')">
                    Format number as 000-000-0000
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- SSN Block -->
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Social Security Number</span>
                <mat-form-field class="form-field" appearance="fill">
                  <mat-label>SSN</mat-label>
                  <input matInput mask="000-00-0000" [type]="showSsn ? 'text' : 'password'" formControlName="ssn" placeholder="XXX-XX-XXXX" />
                  <button mat-icon-button matSuffix [color]="showSsn ? 'primary' : 'warn'" [matTooltip]="showSsn ? 'Hide SSN' : 'Show SSN'"
                          matTooltipShowDelay="800" aria-label="Toggle SSN" (click)="toggleSsn()">
                    <mat-icon>{{ showSsn ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="applicantInfoForm.get('ssn')?.hasError('required')">
                    SSN is required
                  </mat-error>
                  <mat-error *ngIf="applicantInfoForm.get('ssn')?.hasError('minlength') || applicantInfoForm.get('ssn')?.hasError('maxlength')">
                    Please enter a complete SSN
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Address Card  -->
      <mat-card class="md:w-1/2 w-full md:ml-auto" *ngIf="applicationId > 0">
        <mat-card-header>
          <mat-card-title class="pb-4">
            <span class="font-semibold text-xl">Address</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <address [entityId]="applicationId"
                   [entityType]="applicationEntityType"
                   [limitEntries]="true"
                   [isEditable]="isEditable">
          </address>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</form>
